<template>
  <!-- 健康的 -->
  <div>
    <div style="background-color: #fff;width: 100%;height: 100%;">
      <div style="margin: 20px 10px;">{{ tit }}领域综合表现</div>
      <div class="content">
        <div
          style="display: flex;width: 100%;justify-content: space-between;box-sizing: border-box;padding: 10px;"
        >
          <div class="radarCss">
            <verColumnar
              ref="cro"
              :verChartData="croData"
              :verCategories="bomCategories"
              :key="croData.toString()"
            ></verColumnar>
          </div>
          <div class="radarCss">
            <croColumnar
              ref="cro"
              :chartData="verData"
              :categories="bomCategories"
              :key="verData.toString()"
            ></croColumnar>
          </div>
        </div>
        <div
          style="display: flex;justify-content: flex-start;width: 100%;margin-top: 10px;margin-left: 30px;"
          v-if="fieldEvidence.length && !isPdf"
        >
          <div
            :class="[proofIsShow ? 'proofCss' : 'proofCss2']"
            @click="proofJudge"
          >
            {{ proofIsShow ? "关键证据" : "点击查看关联证据" }}
          </div>
          <!-- <div class="proofCells" v-if="proofIsShow">
            <div
              class="proofCell"
              @click="proofBtn"
              v-for="(i, index) in fieldEvidence"
            >
              {{ i.recordDate }}-{{ i.recordTit }}-观察笔记
            </div>
          </div> -->
        </div>
      </div>
    </div>

    <el-dialog
      :title="tit + '记录'"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
      center
    >
      <popTable
        ref="popTab"
        @handleClose="handleClose"
        :userid="userid"
        :year="year"
        :tid="tid"
      ></popTable>
    </el-dialog>
  </div>
</template>

<script>
import croColumnar from "./croColumnar";
import verColumnar from "./verColumnar";
import popTable from "./popTable";
// import { number } from "echarts";
export default {
  components: {
    croColumnar,
    verColumnar,
    popTable
  },
  props: {
    tit: {
      type: String,
      default: ""
    },
    tid: {
      type: String,
      default: ""
    },
    radarData: {
      type: Object,
      default: () => {}
    },
    classScoreData: {
      type: Array,
      default: () => []
    },
    claStuNum: {
      type: Number,
      default: 0
    },
    userid: {
      type: String,
      default: ""
    },
    year: {
      type: String,
      default: ""
    },
    isPdf: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      proofIsShow: false,
      dialogVisible: false,
      croData: [],
      verData: [],
      bomCategories: [],
      fieldEvidence: []
    };
  },
  watch: {
    radarData(newVal, oldVal) {
      console.log("newVal", newVal);
      this.radarData = newVal;
      this.CroMap();
      this.verMap();
      this.getEvidence();
    }
  },
  mounted() {
    // console.log(this.radarData);
    this.CroMap();
    this.verMap();
    this.getEvidence();
  },
  methods: {
    proofJudge() {
      this.proofIsShow = true;
      this.dialogVisible = true;
    },
    // proofBtn() {

    // },
    handleClose() {
      this.dialogVisible = false;
      this.proofIsShow = false;
    },
    // 获取关键证据数据
    getEvidence() {
      // this.isLoading = true;
      let params = {
        uid: this.userid,
        year: this.year,
        txt: this.tid,
        page: 1
      };

      this.ajax
        .get(this.$store.state.api + "selectHealthRecord", params)
        .then(res => {
          // console.log("获取关键证据数据", res);
          this.fieldEvidence = res.data[0];
        }); //
    },
    // 横向柱状图
    CroMap() {
      // console.log(this.classScoreData);
      // console.log(this.tid);

      this.bomCategories = [];
      let raData = this.radarData;
      let healthData = raData[this.tid];
      healthData.forEach(e => {
        this.bomCategories.push(e.sname);
      });

      let croMapData = [];
      healthData.forEach(e => {
        croMapData.push(e[e.id]);
      });
      // console.log("croMapData", croMapData);

      this.croData = this.combineArrays(croMapData);
      // console.log("this.croData",this.croData);
    },
    // 纵向柱状图
    verMap() {
      // 班级平均数据开始
      let newArr = [];
      this.classScoreData.forEach(e => {
        for (let i in e) {
          if (i == this.tid) {
            newArr.push(e[i]);
          }
        }
      });
      // console.log(newArr);
      // 整合学生小分类数据
      let AvaArr = [];
      newArr.forEach(e => {
        AvaArr.push(e.child);
      });

      let AvaArr2 = [];
      AvaArr2 = this.combineArrays(AvaArr);
      let _that = this;

      let att = [];
      AvaArr2.forEach((e, index) => {
        att[index] = [];
        e.forEach(k => {
          att[index] = _that.addArrays(att[index], k);
        });
      });
      // console.log("AvaArr", AvaArr);

      let lastData = [];
      att.forEach((e, index) => {
        let k = 0;
        k = e.reduce((per, cur) => {
          return per + cur;
        }, 0);
        lastData.push(((k / 3 / this.claStuNum) * 1).toFixed(1));
      });
      // console.log("lastData", lastData);
      // 班级平均数据结束

      let raData = this.radarData;
      let healthData = raData[this.tid];
      let croMapData = [];
      healthData.forEach(e => {
        croMapData.push(e[e.id]);
      });
      //   console.log("croMapData", croMapData);
      let app = [];
      croMapData.forEach(e => {
        let a = e.reduce((pre, next, index) => {
          return pre + next;
          //pre+next=10+5=15
        }, 0);
        app.push(a);
      });
      //   console.log(app);
      this.verData = app.map(e => {
        return (e / 3).toFixed(1);
      });
      this.verData = [this.verData, lastData];
      // console.log("this.verData", this.verData);
      // this.healthCroData = this.combineArrays(croMapData);
    },
    // 数据相同下标相加组成一个新数组
    combineArrays(arrays) {
      const result = [];

      // 获取数组中的最大长度
      const maxLength = Math.max(...arrays.map(arr => arr.length));

      // 遍历每个下标
      for (let i = 0; i < maxLength; i++) {
        const combinedItem = [];

        // 遍历每个数组
        for (let j = 0; j < arrays.length; j++) {
          const array = arrays[j];

          // 检查当前下标是否存在于数组中
          if (i < array.length) {
            const item = array[i];

            // 将当前下标的字段添加到组合数组中
            combinedItem.push(item);
          }
        }

        // 将组合数组添加到结果数组中
        result.push(combinedItem);
      }

      return result;
    },

    // 数组相加
    addArrays(array1, array2) {
      const result = [];

      for (let i = 0; i < array2.length; i++) {
        const sum = (array1[i] || 0) + array2[i];
        result.push(sum);
      }

      return result;
    }
  }
};
</script>

<style scoped>
.content {
  width: 100%;
  height: 553px;
  flex-shrink: 0;
  border-radius: 16px;
  border: 1px solid var(--bg3, #e7e7e7);
  background: #fff;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.conTitle {
  width: 70%;
  margin: 20px auto;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.txt {
  flex: 1;
  width: 712px;
  height: 40px;
  line-height: 40px;
  flex-shrink: 0;
  border-radius: 4px;
  background: #f0f2f5;
  margin-left: 5px;
  box-sizing: border-box;
  padding: 0 15px;
}
.radarCss {
  width: 45%;
  height: 400px;
}
.proofCss {
  cursor: pointer;
  color: rgba(0, 0, 0, 0.9);
  font-family: "Microsoft YaHei";
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: 0.7px;
  margin-right: 20px;
}
.proofCss2 {
  cursor: pointer;
  width: 200px;
  text-align: left;
  box-sizing: border-box;
  padding: 4px 20px;
  color: rgba(0, 0, 0, 0.9);
  background-color: #f0f2f5;
  font-family: "Microsoft YaHei";
  border-radius: 3px;
  font-size: 14px;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.7px;
  margin-right: 20px;
}
.proofCells {
  width: 600px;

  /* background-color: aqua; */
  display: flex;
  flex-wrap: wrap;
}
.proofCells > .proofCell {
  width: 45%;
  cursor: pointer;
  margin-right: 20px;
  margin-bottom: 10px;
  box-sizing: border-box;
  padding: 10px 15px;
  border-radius: 8px;
  background: var(--bg, #f0f2f5);
}
</style>



// WEBPACK FOOTER //
// src/components/pages/kindStudentEva/test/component/fieldMap.vue